import React, { useContext, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LclActionMenu from "./LclActionMenu";
import { LclDataContext } from "../../Contexts/LclDataContext";
import clsx from "clsx";
import { statuses } from "../../Mappings";
import { AppStateContext } from "../../Contexts/AppStateContext";

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(0.5),
    fontSize: "13px",
  },
  header: {
    padding: theme.spacing(0.5),
    fontSize: "13px",
    fontWeight: "bold",
  },
  strikeThrough: {
    textDecoration: "line-through",
  },
}));

const LclDataTable = (props) => {
  const { data, truckId, week, day } = props;
  const { createLclModel } = useContext(LclDataContext);
  const lclModel = createLclModel({ week });
  const { scrollToPosition } = useContext(AppStateContext);
  const sortedRows = Object.keys(data).sort(
    (id_A, id_B) =>
      new Date(data[id_A].eventDateTime).valueOf() -
      new Date(data[id_B].eventDateTime).valueOf()
  );
  const classes = useStyles();

  const displayColumns = [
    "eventTimeString",
    "conNoteNum",
    "eventType",
    "branch",
    "sender",
    "location",
    "zone",
    "receiver",
    "eventAddress",
    "eventItems",
    "kg",
    "m3",
    "stopPay",
    "homeDelivery",
    "dpc",
    "totalDPC",
    "approvalState",
    // "signature",
  ];

  // return to uses last position before a refresh was done
  useEffect(() => {
    scrollToPosition();
  }, [data, scrollToPosition]);

  return (
    <Table size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          {displayColumns.map((col) => (
            <TableCell key={col} className={classes.header}>
              {lclModel[col].displayName}
            </TableCell>
          ))}
          <TableCell className={classes.header}>Action</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {sortedRows.map((itemId) => {
          const itemData = data[itemId];
          const strikeThrough =
            itemData.approvalState === statuses.deletedApproved ||
            itemData.approvalState === statuses.hourlyLinked;

          return (
            <TableRow key={itemId}>
              {displayColumns.map((col) => (
                <TableCell
                  key={col}
                  className={clsx(
                    classes.cell,
                    strikeThrough && classes.strikeThrough
                  )}
                >
                  {lclModel[col].displayValue(itemData[col])}
                </TableCell>
              ))}

              <TableCell className={classes.cell}>
                <LclActionMenu
                  truckId={truckId}
                  week={week}
                  day={day}
                  itemId={itemId}
                  itemData={itemData}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default LclDataTable;
